import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Row, Col, ListGroup, Alert } from "react-bootstrap";

/**
 * Props:
 * - show
 * - onHide
 * - reservationsList: array of occurrences for the selected date.
 *    each occurrence shape: { id, institution, email, notes, status, rejectReason, listingDateKey }
 * - onAccept(reservationId)  // kept in signature but unused
 * - onReject(reservationId, rejectReason) // kept in signature but unused
 *
 * NOTE: This modal is view-only — no approve/reject actions.
 */
const ReservationRequestModal = ({ show, onHide, reservationsList = [], onAccept, onReject }) => {

  const [localReservations, setLocalReservations] = useState(reservationsList);
  useEffect(() => setLocalReservations(reservationsList), [reservationsList]);

  const [error, setError] = useState(null);

  return (
    <>
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Reservation Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger" onClose={() => setError(null)} dismissible>{error}</Alert>}

          {(!localReservations || localReservations.length === 0) ? (
            <div>No reservations available.</div>
          ) : (
            <ListGroup variant="flush">
              {localReservations.map((occ, idx) => {
                return (
                  <ListGroup.Item key={`${occ.id || "occ"}-${idx}`}>
                    <Row>
                      <Col xs={4}><strong>Institution:</strong></Col>
                      <Col>{occ.institution || "-"}</Col>
                    </Row>
                    <Row>
                      <Col xs={4}><strong>Email Address:</strong></Col>
                      <Col>{occ.email || "-"}</Col>
                    </Row>
                    <Row>
                      <Col xs={4}><strong>Listing Date:</strong></Col>
                      <Col>{occ.listingDateKey || occ.listingDate || "-"}</Col>
                    </Row>
                    <Row>
                      <Col xs={4}><strong>Status:</strong></Col>
                      <Col>{occ.status || "pending"}</Col>
                    </Row>

                    {occ.notes && (
                      <Row>
                        <Col xs={4}><strong>Notes:</strong></Col>
                        <Col>{occ.notes}</Col>
                      </Row>
                    )}

                    {occ.rejectReason && (
                      <Row>
                        <Col xs={4}><strong>Reject Reason:</strong></Col>
                        <Col>{occ.rejectReason}</Col>
                      </Row>
                    )}
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ReservationRequestModal;
